import React, { forwardRef, useMemo } from 'react';
import jwtService from '@services/jwt.service';
const RedirectForm = forwardRef(({ to, params, target }, ref) => {
    const token = jwtService.getToken();
    const fields = useMemo(() => {
        const defaultParams = { 'jwt-token': token, ...params };
        const names = Object.keys(defaultParams);
        return names.map((name) => {
            return <input key={name} type="hidden" value={defaultParams[name]} name={name}/>;
        });
    }, [params, token]);
    return (<form ref={ref} className="d-none" tabIndex={-1} method="POST" action={to} target={target} data-testid="RedirectForm">
            {fields}
        </form>);
});
RedirectForm.displayName = 'RedirectForm';
export default RedirectForm;
